import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { getHistoryImages } from '../Axios/searchoff';
import PaginationLoe from './PaginationLoe';

const SearchArhivImage = () => {

    const [width, setWidth] = useState(0);
    const [images, setImages] = useState([]);

    const dateFromRef = useRef(null);
    const dateToRef = useRef(null);

    const [page, setPage] = useState(1);
    const [totalItems, setTotal] = useState(1);

    const maxDate = dayjs().format("YYYY-MM-DD");
    const [selectedFrom, setSelectedFrom] = useState(dayjs().subtract(1, "day").format("YYYY-MM-DD"));
    const [selectedTo, setSelectedTo] = useState(dayjs().format("YYYY-MM-DD"));

    const formatFrom = dayjs(selectedFrom).format('YYYY-MM-DDTHH:mm:ssZ[Z]');
    // додати при відправці 1 день для пошуку по дню включно
    const formatTo = dayjs(selectedTo).add(1, "day").format('YYYY-MM-DDTHH:mm:ssZ[Z]');

    useEffect(()=>{
        const initFrom = dayjs().subtract(1, "day").startOf('day').format("YYYY-MM-DDTHH:mm:ssZ[Z]");
        const initTo = dayjs().add(1, "day").startOf('day').format('YYYY-MM-DDTHH:mm:ssZ[Z]');
        getHistoryImages(initFrom, initTo, 1).then(response=>{
            const data = response['hydra:member'];
            setTotal(response['hydra:totalItems'])
            setImages(data);
        }).catch((err)=> {
            toast.error(`Помилка обробки даних ${err.message}`, {
                position: toast.POSITION.BOTTOM_LEFT
            });
        })
    },[])

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const handleResize = () => setWidth(window.innerWidth);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);

    function getData(page) {
        getHistoryImages(formatFrom, formatTo, page).then(response=>{
            const data = response['hydra:member'];
            const total = response['hydra:totalItems'];
            setTotal(total);
            setImages(data);
            if (total === 0) {
                toast.error(`Даних не знайдено`, {
                    position: toast.POSITION.BOTTOM_LEFT
                });
            }
        }).catch((err)=> {
            toast.error(`Помилка обробки даних ${err.message}`, {
                position: toast.POSITION.BOTTOM_LEFT
            });
        })
    }

    function submitData(){
        setPage(1);
        getData(1);
    }

    const handleChangePage = (currentPage)=> {
        window.scrollTo(0,0);
        setPage(currentPage);
        getData(currentPage);
    }

    return <div className="search-arhiv-images">
            <div className="period-inner">
                <div className="period-inner__field">
                <label htmlFor="from">Період з</label>
                <div className="picker-inner">
                <DatePicker
                    selected={selectedFrom ? new Date(selectedFrom) : null}
                    onChange={(date)=> {setSelectedFrom(date)}}
                    maxDate={maxDate}
                    locale="uk"
                    dateFormat="dd.MM.yyyy"
                    placeholderText="Оберіть дату"
                    className={"date-input"}
                    ref={dateFromRef}
                />
                    <i class="fa fa-calendar" onClick={() => dateFromRef.current.setOpen(true)}></i>
                </div>
                </div>
                <div className="period-inner__field">
                <label htmlFor="to">Період по</label>
                <div className="picker-inner">
                <DatePicker
                    selected={selectedTo ? new Date(selectedTo) : null}
                    onChange={(date)=> {setSelectedTo(date)}}
                    maxDate={maxDate}
                    locale="uk"
                    dateFormat="dd.MM.yyyy"
                    placeholderText="Оберіть дату"
                    className={"date-input"}
                    ref={dateToRef}
                />
                <i class="fa fa-calendar" onClick={() => dateToRef.current.setOpen(true)}></i>
                </div>
                </div>
            </div>           
            <button onClick={submitData} className='power-btn'>Вибрати</button>
            {images.length > 0 && <>
                <div className="images-inner">
                    {images.map(img => {
                        return <div key={img.id} className='images-element'>
                                    {width <= 768 
                                        ? <img  height="100%" width="100%" src={process.env.REACT_APP_SERVER_SEARCH_URL + img?.imageMobileUrl?.contentUrl} alt="arhiv-mobile" /> 
                                        : <img  height="100%" width="100%" src={process.env.REACT_APP_SERVER_SEARCH_URL + img?.imageUrl?.contentUrl} alt="arhiv" />}
                                    <div className='images-html' dangerouslySetInnerHTML={{__html: img?.rawHtml}}></div>
                               </div> 
                            })
                }
                </div>
                <PaginationLoe
                    changePage={handleChangePage}
                    currentPage={page}
                    total={totalItems}
                    limit={30} 
                />
            </>}
        <ToastContainer/>
    </div>
}

export default SearchArhivImage